/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface ScheduledJobHistoryViewModel {
  id?: string;
  name?: string | null;
  executionDate?: string;
  runTimeSeconds?: number;
  exitStatus?: string | null;
  resultStatus?: number;
  resultSetSize?: number;
  isSysAdminJob?: boolean | null;
}
